import { render, staticRenderFns } from "./SpeechAndLanguageWrapper.vue?vue&type=template&id=78c8da47"
import script from "./SpeechAndLanguageWrapper.vue?vue&type=script&lang=js"
export * from "./SpeechAndLanguageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c8da47')) {
      api.createRecord('78c8da47', component.options)
    } else {
      api.reload('78c8da47', component.options)
    }
    module.hot.accept("./SpeechAndLanguageWrapper.vue?vue&type=template&id=78c8da47", function () {
      api.rerender('78c8da47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/SpeechAndLanguageWrapper.vue"
export default component.exports